"use strict";

// Copyright 2021-2025 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var _slicedToArray = require("G:\\__main\\_work\\_projects\\Cinemex\\cinemex-2018-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");
var _regeneratorRuntime = require("G:\\__main\\_work\\_projects\\Cinemex\\cinemex-2018-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");
var _classCallCheck = require("G:\\__main\\_work\\_projects\\Cinemex\\cinemex-2018-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _createClass = require("G:\\__main\\_work\\_projects\\Cinemex\\cinemex-2018-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reflect = reflect;
exports.reflectList = reflectList;
exports.reflectMap = reflectMap;
var descriptors_js_1 = require("../descriptors.js");
var reflect_check_js_1 = require("./reflect-check.js");
var error_js_1 = require("./error.js");
var unsafe_js_1 = require("./unsafe.js");
var create_js_1 = require("../create.js");
var wrappers_js_1 = require("../wkt/wrappers.js");
var scalar_js_1 = require("./scalar.js");
var proto_int64_js_1 = require("../proto-int64.js");
var guard_js_1 = require("./guard.js");
/**
 * Create a ReflectMessage.
 */
function reflect(messageDesc, message) {
  var check = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return new ReflectMessageImpl(messageDesc, message, check);
}
var ReflectMessageImpl = /*#__PURE__*/function () {
  _createClass(ReflectMessageImpl, [{
    key: "sortedFields",
    get: function get() {
      var _a;
      return (_a = this._sortedFields) !== null && _a !== void 0 ? _a :
      // biome-ignore lint/suspicious/noAssignInExpressions: no
      this._sortedFields = this.desc.fields.concat().sort(function (a, b) {
        return a.number - b.number;
      });
    }
  }]);
  function ReflectMessageImpl(messageDesc, message) {
    var check = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    _classCallCheck(this, ReflectMessageImpl);
    this.lists = new Map();
    this.maps = new Map();
    this.check = check;
    this.desc = messageDesc;
    this.message = this[unsafe_js_1.unsafeLocal] = message !== null && message !== void 0 ? message : (0, create_js_1.create)(messageDesc);
    this.fields = messageDesc.fields;
    this.oneofs = messageDesc.oneofs;
    this.members = messageDesc.members;
  }
  _createClass(ReflectMessageImpl, [{
    key: "findNumber",
    value: function findNumber(number) {
      if (!this._fieldsByNumber) {
        this._fieldsByNumber = new Map(this.desc.fields.map(function (f) {
          return [f.number, f];
        }));
      }
      return this._fieldsByNumber.get(number);
    }
  }, {
    key: "oneofCase",
    value: function oneofCase(oneof) {
      assertOwn(this.message, oneof);
      return (0, unsafe_js_1.unsafeOneofCase)(this.message, oneof);
    }
  }, {
    key: "isSet",
    value: function isSet(field) {
      assertOwn(this.message, field);
      return (0, unsafe_js_1.unsafeIsSet)(this.message, field);
    }
  }, {
    key: "clear",
    value: function clear(field) {
      assertOwn(this.message, field);
      (0, unsafe_js_1.unsafeClear)(this.message, field);
    }
  }, {
    key: "get",
    value: function get(field) {
      assertOwn(this.message, field);
      var value = (0, unsafe_js_1.unsafeGet)(this.message, field);
      switch (field.fieldKind) {
        case "list":
          // eslint-disable-next-line no-case-declarations
          var list = this.lists.get(field);
          if (!list || list[unsafe_js_1.unsafeLocal] !== value) {
            this.lists.set(field,
            // biome-ignore lint/suspicious/noAssignInExpressions: no
            list = new ReflectListImpl(field, value, this.check));
          }
          return list;
        case "map":
          var map = this.maps.get(field);
          if (!map || map[unsafe_js_1.unsafeLocal] !== value) {
            this.maps.set(field,
            // biome-ignore lint/suspicious/noAssignInExpressions: no
            map = new ReflectMapImpl(field, value, this.check));
          }
          return map;
        case "message":
          return messageToReflect(field, value, this.check);
        case "scalar":
          return value === undefined ? (0, scalar_js_1.scalarZeroValue)(field.scalar, false) : longToReflect(field, value);
        case "enum":
          return value !== null && value !== void 0 ? value : field.enum.values[0].number;
      }
    }
  }, {
    key: "set",
    value: function set(field, value) {
      assertOwn(this.message, field);
      if (this.check) {
        var err = (0, reflect_check_js_1.checkField)(field, value);
        if (err) {
          throw err;
        }
      }
      var local;
      if (field.fieldKind == "message") {
        local = messageToLocal(field, value);
      } else if ((0, guard_js_1.isReflectMap)(value) || (0, guard_js_1.isReflectList)(value)) {
        local = value[unsafe_js_1.unsafeLocal];
      } else {
        local = longToLocal(field, value);
      }
      (0, unsafe_js_1.unsafeSet)(this.message, field, local);
    }
  }, {
    key: "getUnknown",
    value: function getUnknown() {
      return this.message.$unknown;
    }
  }, {
    key: "setUnknown",
    value: function setUnknown(value) {
      this.message.$unknown = value;
    }
  }]);
  return ReflectMessageImpl;
}();
function assertOwn(owner, member) {
  if (member.parent.typeName !== owner.$typeName) {
    throw new error_js_1.FieldError(member, "cannot use ".concat(member.toString(), " with message ").concat(owner.$typeName), "ForeignFieldError");
  }
}
/**
 * Create a ReflectList.
 */
function reflectList(field, unsafeInput) {
  var check = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return new ReflectListImpl(field, unsafeInput !== null && unsafeInput !== void 0 ? unsafeInput : [], check);
}
var ReflectListImpl = /*#__PURE__*/function () {
  _createClass(ReflectListImpl, [{
    key: "field",
    value: function field() {
      return this._field;
    }
  }, {
    key: "size",
    get: function get() {
      return this._arr.length;
    }
  }]);
  function ReflectListImpl(field, unsafeInput, check) {
    _classCallCheck(this, ReflectListImpl);
    this._field = field;
    this._arr = this[unsafe_js_1.unsafeLocal] = unsafeInput;
    this.check = check;
  }
  _createClass(ReflectListImpl, [{
    key: "get",
    value: function get(index) {
      var item = this._arr[index];
      return item === undefined ? undefined : listItemToReflect(this._field, item, this.check);
    }
  }, {
    key: "set",
    value: function set(index, item) {
      if (index < 0 || index >= this._arr.length) {
        throw new error_js_1.FieldError(this._field, "list item #".concat(index + 1, ": out of range"));
      }
      if (this.check) {
        var err = (0, reflect_check_js_1.checkListItem)(this._field, index, item);
        if (err) {
          throw err;
        }
      }
      this._arr[index] = listItemToLocal(this._field, item);
    }
  }, {
    key: "add",
    value: function add(item) {
      if (this.check) {
        var err = (0, reflect_check_js_1.checkListItem)(this._field, this._arr.length, item);
        if (err) {
          throw err;
        }
      }
      this._arr.push(listItemToLocal(this._field, item));
      return undefined;
    }
  }, {
    key: "clear",
    value: function clear() {
      this._arr.splice(0, this._arr.length);
    }
  }, {
    key: Symbol.iterator,
    value: function value() {
      return this.values();
    }
  }, {
    key: "keys",
    value: function keys() {
      return this._arr.keys();
    }
  }, {
    key: "values",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function values() {
      var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item;
      return _regeneratorRuntime.wrap(function values$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 3;
              _iterator = this._arr[Symbol.iterator]();
            case 5:
              if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                _context.next = 12;
                break;
              }
              item = _step.value;
              _context.next = 9;
              return listItemToReflect(this._field, item, this.check);
            case 9:
              _iteratorNormalCompletion = true;
              _context.next = 5;
              break;
            case 12:
              _context.next = 18;
              break;
            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](3);
              _didIteratorError = true;
              _iteratorError = _context.t0;
            case 18:
              _context.prev = 18;
              _context.prev = 19;
              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }
            case 21:
              _context.prev = 21;
              if (!_didIteratorError) {
                _context.next = 24;
                break;
              }
              throw _iteratorError;
            case 24:
              return _context.finish(21);
            case 25:
              return _context.finish(18);
            case 26:
            case "end":
              return _context.stop();
          }
        }
      }, values, this, [[3, 14, 18, 26], [19,, 21, 25]]);
    })
  }, {
    key: "entries",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function entries() {
      var i;
      return _regeneratorRuntime.wrap(function entries$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              i = 0;
            case 1:
              if (!(i < this._arr.length)) {
                _context2.next = 7;
                break;
              }
              _context2.next = 4;
              return [i, listItemToReflect(this._field, this._arr[i], this.check)];
            case 4:
              i++;
              _context2.next = 1;
              break;
            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, entries, this);
    })
  }]);
  return ReflectListImpl;
}();
/**
 * Create a ReflectMap.
 */
function reflectMap(field, unsafeInput) {
  var check = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return new ReflectMapImpl(field, unsafeInput, check);
}
var ReflectMapImpl = /*#__PURE__*/function () {
  function ReflectMapImpl(field, unsafeInput) {
    var check = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    _classCallCheck(this, ReflectMapImpl);
    this.obj = this[unsafe_js_1.unsafeLocal] = unsafeInput !== null && unsafeInput !== void 0 ? unsafeInput : {};
    this.check = check;
    this._field = field;
  }
  _createClass(ReflectMapImpl, [{
    key: "field",
    value: function field() {
      return this._field;
    }
  }, {
    key: "set",
    value: function set(key, value) {
      if (this.check) {
        var err = (0, reflect_check_js_1.checkMapEntry)(this._field, key, value);
        if (err) {
          throw err;
        }
      }
      this.obj[mapKeyToLocal(key)] = mapValueToLocal(this._field, value);
      return this;
    }
  }, {
    key: "delete",
    value: function _delete(key) {
      var k = mapKeyToLocal(key);
      var has = Object.prototype.hasOwnProperty.call(this.obj, k);
      if (has) {
        delete this.obj[k];
      }
      return has;
    }
  }, {
    key: "clear",
    value: function clear() {
      for (var _i = 0, _Object$keys = Object.keys(this.obj); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        delete this.obj[key];
      }
    }
  }, {
    key: "get",
    value: function get(key) {
      var val = this.obj[mapKeyToLocal(key)];
      if (val !== undefined) {
        val = mapValueToReflect(this._field, val, this.check);
      }
      return val;
    }
  }, {
    key: "has",
    value: function has(key) {
      return Object.prototype.hasOwnProperty.call(this.obj, mapKeyToLocal(key));
    }
  }, {
    key: "keys",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function keys() {
      var _i2, _Object$keys2, objKey;
      return _regeneratorRuntime.wrap(function keys$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _i2 = 0, _Object$keys2 = Object.keys(this.obj);
            case 1:
              if (!(_i2 < _Object$keys2.length)) {
                _context3.next = 8;
                break;
              }
              objKey = _Object$keys2[_i2];
              _context3.next = 5;
              return mapKeyToReflect(objKey, this._field.mapKey);
            case 5:
              _i2++;
              _context3.next = 1;
              break;
            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, keys, this);
    })
  }, {
    key: "entries",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function entries() {
      var _i3, _Object$entries, objEntry;
      return _regeneratorRuntime.wrap(function entries$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _i3 = 0, _Object$entries = Object.entries(this.obj);
            case 1:
              if (!(_i3 < _Object$entries.length)) {
                _context4.next = 8;
                break;
              }
              objEntry = _Object$entries[_i3];
              _context4.next = 5;
              return [mapKeyToReflect(objEntry[0], this._field.mapKey), mapValueToReflect(this._field, objEntry[1], this.check)];
            case 5:
              _i3++;
              _context4.next = 1;
              break;
            case 8:
            case "end":
              return _context4.stop();
          }
        }
      }, entries, this);
    })
  }, {
    key: Symbol.iterator,
    value: function value() {
      return this.entries();
    }
  }, {
    key: "values",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function values() {
      var _i4, _Object$values, val;
      return _regeneratorRuntime.wrap(function values$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _i4 = 0, _Object$values = Object.values(this.obj);
            case 1:
              if (!(_i4 < _Object$values.length)) {
                _context5.next = 8;
                break;
              }
              val = _Object$values[_i4];
              _context5.next = 5;
              return mapValueToReflect(this._field, val, this.check);
            case 5:
              _i4++;
              _context5.next = 1;
              break;
            case 8:
            case "end":
              return _context5.stop();
          }
        }
      }, values, this);
    })
  }, {
    key: "forEach",
    value: function forEach(callbackfn, thisArg) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;
      try {
        for (var _iterator2 = this.entries()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var mapEntry = _step2.value;
          callbackfn.call(thisArg, mapEntry[1], mapEntry[0], this);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  }, {
    key: "size",
    get: function get() {
      return Object.keys(this.obj).length;
    }
  }]);
  return ReflectMapImpl;
}();
function messageToLocal(field, value) {
  if (!(0, guard_js_1.isReflectMessage)(value)) {
    return value;
  }
  if ((0, wrappers_js_1.isWrapper)(value.message) && !field.oneof && field.fieldKind == "message") {
    // Types from google/protobuf/wrappers.proto are unwrapped when used in
    // a singular field that is not part of a oneof group.
    return value.message.value;
  }
  if (value.desc.typeName == "google.protobuf.Struct" && field.parent.typeName != "google.protobuf.Value") {
    // google.protobuf.Struct is represented with JsonObject when used in a
    // field, except when used in google.protobuf.Value.
    return wktStructToLocal(value.message);
  }
  return value.message;
}
function messageToReflect(field, value, check) {
  if (value !== undefined) {
    if ((0, wrappers_js_1.isWrapperDesc)(field.message) && !field.oneof && field.fieldKind == "message") {
      // Types from google/protobuf/wrappers.proto are unwrapped when used in
      // a singular field that is not part of a oneof group.
      value = {
        $typeName: field.message.typeName,
        value: longToReflect(field.message.fields[0], value)
      };
    } else if (field.message.typeName == "google.protobuf.Struct" && field.parent.typeName != "google.protobuf.Value" && (0, guard_js_1.isObject)(value)) {
      // google.protobuf.Struct is represented with JsonObject when used in a
      // field, except when used in google.protobuf.Value.
      value = wktStructToReflect(value);
    }
  }
  return new ReflectMessageImpl(field.message, value, check);
}
function listItemToLocal(field, value) {
  if (field.listKind == "message") {
    return messageToLocal(field, value);
  }
  return longToLocal(field, value);
}
function listItemToReflect(field, value, check) {
  if (field.listKind == "message") {
    return messageToReflect(field, value, check);
  }
  return longToReflect(field, value);
}
function mapValueToLocal(field, value) {
  if (field.mapKind == "message") {
    return messageToLocal(field, value);
  }
  return longToLocal(field, value);
}
function mapValueToReflect(field, value, check) {
  if (field.mapKind == "message") {
    return messageToReflect(field, value, check);
  }
  return value;
}
function mapKeyToLocal(key) {
  return typeof key == "string" || typeof key == "number" ? key : String(key);
}
/**
 * Converts a map key (any scalar value except float, double, or bytes) from its
 * representation in a message (string or number, the only possible object key
 * types) to the closest possible type in ECMAScript.
 */
function mapKeyToReflect(key, type) {
  switch (type) {
    case descriptors_js_1.ScalarType.STRING:
      return key;
    case descriptors_js_1.ScalarType.INT32:
    case descriptors_js_1.ScalarType.FIXED32:
    case descriptors_js_1.ScalarType.UINT32:
    case descriptors_js_1.ScalarType.SFIXED32:
    case descriptors_js_1.ScalarType.SINT32:
      {
        var n = Number.parseInt(key);
        if (Number.isFinite(n)) {
          return n;
        }
        break;
      }
    case descriptors_js_1.ScalarType.BOOL:
      switch (key) {
        case "true":
          return true;
        case "false":
          return false;
      }
      break;
    case descriptors_js_1.ScalarType.UINT64:
    case descriptors_js_1.ScalarType.FIXED64:
      try {
        return proto_int64_js_1.protoInt64.uParse(key);
      } catch (_a) {
        //
      }
      break;
    default:
      // INT64, SFIXED64, SINT64
      try {
        return proto_int64_js_1.protoInt64.parse(key);
      } catch (_b) {
        //
      }
      break;
  }
  return key;
}
function longToReflect(field, value) {
  switch (field.scalar) {
    case descriptors_js_1.ScalarType.INT64:
    case descriptors_js_1.ScalarType.SFIXED64:
    case descriptors_js_1.ScalarType.SINT64:
      if ("longAsString" in field && field.longAsString && typeof value == "string") {
        value = proto_int64_js_1.protoInt64.parse(value);
      }
      break;
    case descriptors_js_1.ScalarType.FIXED64:
    case descriptors_js_1.ScalarType.UINT64:
      if ("longAsString" in field && field.longAsString && typeof value == "string") {
        value = proto_int64_js_1.protoInt64.uParse(value);
      }
      break;
  }
  return value;
}
function longToLocal(field, value) {
  switch (field.scalar) {
    case descriptors_js_1.ScalarType.INT64:
    case descriptors_js_1.ScalarType.SFIXED64:
    case descriptors_js_1.ScalarType.SINT64:
      if ("longAsString" in field && field.longAsString) {
        value = String(value);
      } else if (typeof value == "string" || typeof value == "number") {
        value = proto_int64_js_1.protoInt64.parse(value);
      }
      break;
    case descriptors_js_1.ScalarType.FIXED64:
    case descriptors_js_1.ScalarType.UINT64:
      if ("longAsString" in field && field.longAsString) {
        value = String(value);
      } else if (typeof value == "string" || typeof value == "number") {
        value = proto_int64_js_1.protoInt64.uParse(value);
      }
      break;
  }
  return value;
}
function wktStructToReflect(json) {
  var struct = {
    $typeName: "google.protobuf.Struct",
    fields: {}
  };
  if ((0, guard_js_1.isObject)(json)) {
    for (var _i5 = 0, _Object$entries2 = Object.entries(json); _i5 < _Object$entries2.length; _i5++) {
      var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i5], 2),
        k = _Object$entries2$_i[0],
        v = _Object$entries2$_i[1];
      struct.fields[k] = wktValueToReflect(v);
    }
  }
  return struct;
}
function wktStructToLocal(val) {
  var json = {};
  for (var _i6 = 0, _Object$entries3 = Object.entries(val.fields); _i6 < _Object$entries3.length; _i6++) {
    var _Object$entries3$_i = _slicedToArray(_Object$entries3[_i6], 2),
      k = _Object$entries3$_i[0],
      v = _Object$entries3$_i[1];
    json[k] = wktValueToLocal(v);
  }
  return json;
}
function wktValueToLocal(val) {
  switch (val.kind.case) {
    case "structValue":
      return wktStructToLocal(val.kind.value);
    case "listValue":
      return val.kind.value.values.map(wktValueToLocal);
    case "nullValue":
    case undefined:
      return null;
    default:
      return val.kind.value;
  }
}
function wktValueToReflect(json) {
  var value = {
    $typeName: "google.protobuf.Value",
    kind: {
      case: undefined
    }
  };
  switch (typeof json) {
    case "number":
      value.kind = {
        case: "numberValue",
        value: json
      };
      break;
    case "string":
      value.kind = {
        case: "stringValue",
        value: json
      };
      break;
    case "boolean":
      value.kind = {
        case: "boolValue",
        value: json
      };
      break;
    case "object":
      if (json === null) {
        var nullValue = 0;
        value.kind = {
          case: "nullValue",
          value: nullValue
        };
      } else if (Array.isArray(json)) {
        var listValue = {
          $typeName: "google.protobuf.ListValue",
          values: []
        };
        if (Array.isArray(json)) {
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;
          try {
            for (var _iterator3 = json[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var e = _step3.value;
              listValue.values.push(wktValueToReflect(e));
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        }
        value.kind = {
          case: "listValue",
          value: listValue
        };
      } else {
        value.kind = {
          case: "structValue",
          value: wktStructToReflect(json)
        };
      }
      break;
  }
  return value;
}